import type { Span } from '@opentelemetry/api';
import type { LogRecordProcessor, SdkLogRecord } from '@opentelemetry/sdk-logs';
import { NoopSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { applyClientMetadata } from './clientMetadata';

export class ClientMetadataSpanProcessor extends NoopSpanProcessor {
  onStart(span: Span): void {
    applyClientMetadata(span);
  }
}

export class ClientMetadataLogRecordProcessor implements LogRecordProcessor {
  onEmit(logRecord: SdkLogRecord): void {
    applyClientMetadata(logRecord);
  }
  forceFlush(): Promise<void> {
    return Promise.resolve();
  }
  shutdown(): Promise<void> {
    return Promise.resolve();
  }
}
